import { IconButton, makeStyles } from "@material-ui/core";
import { useState } from "react";
import ReactDOM from "react-dom";
import { ReactComponent as HeatmapIcon } from '../../images/heatmapIcon.svg';

import { useControl } from 'react-map-gl';
import mapboxgl from 'mapbox-gl';

export const HeatmapControl = ({ onToggle }: { onToggle: (active: boolean) => void }) => {
  useControl(() => {
    return new ResizeControlClass(onToggle);
  }, { position: 'top-left' });

  return null;
}

class ResizeControlClass implements mapboxgl.IControl {
  _container: HTMLElement;
  constructor(
    private onToggle: (active: boolean) => void,
  ) {
    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
  }
  onAdd(): HTMLElement {
    ReactDOM.render(
      <HeatmapControlUI onToggle={this.onToggle} />,
      this._container
    );
    return this._container;
  }
  onRemove() {
    ReactDOM.unmountComponentAtNode(this._container);
    this._container.remove();
  }
}

const useControlsStyles = makeStyles(() => ({
  button: {
    padding: 8,
    margin: 2,
    width: "26px !important",
    height: "26px !important"
  },
  icon: {
    width: "16px",
    height: "16px",
    color: "#000000"
  }
}));

interface HeatmapControlUIProps {
  onToggle: (active: boolean) => void;
}

const HeatmapControlUI: React.FC<HeatmapControlUIProps> = ({ onToggle = (active: boolean) => {/** Nothing to do here */ } }) => {
  const [active, setActive] = useState(false);
  const classes = useControlsStyles();

  const handleClick = () => {
    setActive((prev) => {
      onToggle(!prev);
      return !prev;
    });
  };

  return (
    <IconButton
      title="Price/Sq.Ft Heatmap"
      onClick={handleClick}
      className={classes.button}
      style={{ backgroundColor: active ? '#d8d8d8' : 'white' }}
    >
      <HeatmapIcon className={classes.icon} />
    </IconButton>
  );
};